import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "tipsMain" }
const _hoisted_2 = {
  key: 0,
  class: "tips"
}
const _hoisted_3 = {
  key: 0,
  class: "tipsList"
}
const _hoisted_4 = {
  key: 1,
  class: "callToAction"
}
const _hoisted_5 = { class: "callToActionButtonContainer" }
const _hoisted_6 = {
  key: 1,
  class: "share"
}
const _hoisted_7 = { class: "formBorder" }
const _hoisted_8 = { class: "formFooter" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.visible === _ctx.TipsView.TIPS)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[5] || (_cache[5] = _createElementVNode("h3", null, "Tips", -1)),
          _createElementVNode("div", null, [
            (_ctx.tips.length)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tips, (tip, index) => {
                    return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(tip.body), 1))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_4, " No one has left a tip here yet! Click the \"Share a new tip\" button below to share your knowledge on this topic. "))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              "aria-label": "Click to share a new tip",
              alt: "Share new tip button",
              title: "Share a new tip",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setVisible(_ctx.TipsView.SHARE)))
            }, " Share a new tip ")
          ])
        ]))
      : (_ctx.visible === _ctx.TipsView.SHARE)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _cache[6] || (_cache[6] = _createElementVNode("h3", null, "Share a tip", -1)),
            _createElementVNode("form", {
              class: "form",
              onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.shareTip && _ctx.shareTip(...args)), ["prevent"]))
            }, [
              _createElementVNode("button", {
                class: "closeButton",
                "aria-label": "Close tip input",
                alt: "Button to close tip input",
                title: "Close",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setVisible(_ctx.TipsView.TIPS)))
              }, [
                _createVNode(_component_ion_icon, {
                  class: "closeIcon",
                  name: "close-circle-outline"
                })
              ]),
              _createElementVNode("div", _hoisted_7, [
                _withDirectives(_createElementVNode("textarea", {
                  name: "tip",
                  "aria-label": "Tip to share",
                  placeholder: "Enter new tip to share",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tip) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.tip]
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("button", {
                    class: "cancelButton",
                    alt: "Button to close tip input",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setVisible(_ctx.TipsView.TIPS)))
                  }, " Cancel "),
                  _createElementVNode("button", {
                    class: "shareButton",
                    type: "submit",
                    disabled: !_ctx.tip
                  }, " Share ", 8, _hoisted_9)
                ])
              ])
            ], 32)
          ]))
        : (_ctx.visible === _ctx.TipsView.THANKS)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[7] || (_cache[7] = [
              _createElementVNode("h3", null, "Thank you!", -1),
              _createElementVNode("p", null, "Your tip has been shared.", -1)
            ]))]))
          : _createCommentVNode("", true)
  ]))
}